import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { currencyFormatter } from 'views/versions/tabs/Constfunctions';

const colors = ['#002A4E', '#50C0C0', '#404040', '#FFC000'];

const BarChartCards = ({ allTilesData }) => {
  const cards = [
    {
      id: 1,
      title: 'Open Opportunities',
      value: allTilesData[3]?.Value ?? 0,
      count: allTilesData[0]?.Value ?? 0
    },
    {
      id: 2,
      title: 'Closed Won',
      value: allTilesData[4]?.Value ?? 0,
      count: allTilesData[2]?.Value ?? 0
    },
    {
      id: 3,
      title: 'Closed Lost',
      value: allTilesData[5]?.Value ?? 0,
      count: allTilesData[1]?.Value ?? 0
    },
    {
      id: 4,
      title: 'Duration of Open Opportunities (in weeks)',
      value: allTilesData[6]?.Value ?? 0,
      count: null
    }
  ];

  return (
    <Box
      sx={{
        mt: 3,
        ml: 'auto',
        mr: 'auto',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(200px, 100%), 1fr))',
        gap: 2,
      }}
    >
      {cards.map((card, index) => (
        <Card key={index}>
          <CardActionArea
            style={{ background: colors[index % colors.length] }}
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              height: '98%',
              '&[data-active]': {
                backgroundColor: '#5e35b1',
                '&:hover': {
                  backgroundColor: 'action.selectedHover'
                }
              },
            }}
          >
            <CardContent sx={{ height: '100%', pt: 2, pb: 2, pl: 1, pr: 1 }}>
              {card ? (
                <Typography variant="h2" style={{ color: '#ffffff' }} align="center" sx={{ p: 1}}>
                  {card.count}
                </Typography>
              ) : null}
              <Typography variant="h5" component="div" align="center" style={{ color: '#ffffff' }}>
                {card.title}
              </Typography>
              {index === 3 ? (
                <Typography variant="h2" style={{ color: '#ffffff' }} align="center" sx={{ p: 1 }}>
                  {card.value}
                </Typography>
              ) : (
                <Typography variant="h2" style={{ color: '#ffffff' }} align="center" sx={{ p: 1 }}>
                  {currencyFormatter(card.value)}
                </Typography>
              )}
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};

export default BarChartCards;
